import { styledComponent } from '@hermes/web-components'

export const Button = styledComponent('button')`
  border: none;
  background-color: transparent;
  `

export const Container = styledComponent('div')`
  width: calc(100vw - ((100vw - 1064px) / 2));
  @media (max-width: 1200px) {
    width: calc(100% + 16px)
  }
  `

export const ButtonsContainer = styledComponent('div')(({ theme }) => ({
  marginTop: '32px',
  display: 'flex',
  gap: '32px',
  [theme.breakpoints.down('md')]: {
    marginTop: '24px'
  }
}))
